import { Aspect } from '@teambit/harmony';

export const ComponentCompareAspect = Aspect.create({
  id: 'teambit.component/component-compare',
});

export default ComponentCompareAspect;
